export default __webpack_public_path__ + "static/media/PinkFrame04.124b717f.png";